import React from 'react';
import { observer } from 'mobx-react-lite';
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Box } from '@mui/material';
import { useRootStore } from '../../../store/contexts';

interface StoreTableRow {
  path: string;
  type: string;
  status: string;
}

export const StoresTab: React.FC = observer(() => {
  const rootStore = useRootStore();
  const langStore = rootStore.langStore;

  const allStores = rootStore.storeRegistry.allStores;
  const paths = rootStore.storeRegistry.allPaths;

  const storeData: StoreTableRow[] = allStores.map((store: any, index: number) => ({
    path: paths[index] || 'unknown',
    type: store.constructor.name,
    status: store.status || 'active',
  }));

  const columns: MRT_ColumnDef<StoreTableRow>[] = [
    {
      accessorKey: 'path',
      header: langStore.monitorPathname,
      size: 300,
    },
    {
      accessorKey: 'type',
      header: langStore.monitorStoreType,
      size: 200,
    },
    {
      accessorKey: 'status',
      header: langStore.monitorStatus,
      size: 150,
    },
  ];

  return (
    <Box sx={{ p: 2 }}>

      <MaterialReactTable
        columns={columns}
        data={storeData}
        enableColumnResizing
        enableColumnOrdering
        enableDensityToggle
        enableFullScreenToggle={false}
        initialState={{
          density: 'compact',
        }}
        muiTableProps={{
          sx: {
            tableLayout: 'fixed',
          },
        }}
        muiTableBodyCellProps={{
          sx: {
            fontSize: '0.75rem',
          },
        }}
        muiTableHeadCellProps={{
          sx: {
            fontSize: '0.75rem',
            fontWeight: 600,
          },
        }}
      />
    </Box>
  );
});
